import {
  BlockBaseApi,
  BlockBaseModel,
  BlockBaseScore,
  // IBlock,
  IBlockAnswer,
  IBlockScore,
  TScoreHandler,
} from '@skyeng/libs/shared/blocks/core';

// Это тип того что хранится в value ответа
type PythonValue = {
  testSuitePassed: boolean;
};

// Это тип самого ответа, мы хотим использовать IBlockAnswer чтобы не переписывать методы модели под новый интерфейс
type PythonAnswer = IBlockAnswer<PythonValue>;

// Это тип стейта упражнения
type PythonState = {
  code?: string;
};

// Это тип для новых ответов в методе addNewAnswer
type PythonNewAnswer = Partial<PythonAnswer>;

export class PythonModel extends BlockBaseModel<PythonValue, PythonState, PythonAnswer, unknown, PythonNewAnswer> {}
export class PythonScore extends BlockBaseScore<PythonModel, PythonAnswer, unknown> {
  protected getHandlers(): TScoreHandler<unknown, unknown>[] {
    const answers = this.model?.getAnswers();
    const score = this.mapAnswersToScore(answers);

    return [() => score];
  }

  private mapAnswersToScore(answers: PythonAnswer[] | undefined): IBlockScore {
    const startingScore = this.getStartingScore();
    if (!answers) {
      return startingScore;
    }

    if (answers.length === 0) {
      return startingScore;
    }

    // Учитываем только первые 10 ответов, т.к. мы можем отнять только 10 баллов за непаравильные ответы
    const answersToCount = answers.slice(0, 10);

    const rightAnswerIndex = answersToCount.findIndex(answer => answer.value.testSuitePassed === true);
    const hasRightAnswer = rightAnswerIndex !== -1;
    const maxScore = startingScore.maxScore;
    if (hasRightAnswer) {
      const right = hasRightAnswer ? maxScore - rightAnswerIndex : 0;
      const wrong = maxScore - right;

      return {
        maxScore,
        right,
        wrong,
      };
    }

    return {
      maxScore,
      right: 0,
      wrong: answersToCount.length,
    };
  }

  protected getStartingScore(): IBlockScore {
    return {
      right: 0,
      wrong: 0,
      maxScore: 10,
    };
  }
}

export class PythonBlockApi extends BlockBaseApi<PythonAnswer, PythonState, PythonModel, PythonScore> {}
